/**
 * @generated SignedSource<<33aef845909e99047e9173ba55595e0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type commentQueueQuery$data = {
  readonly commentQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"commentContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly commentSection: {
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"followButtonBase">;
  };
  readonly harryContents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"harryContentItemContent">;
      };
    }>;
  };
  readonly " $fragmentType": "commentQueueQuery";
};
export type commentQueueQuery$key = {
  readonly " $data"?: commentQueueQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentQueueQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentHarrySectionIds"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "commentLimit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentQueueName"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "harrysViewLimit"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "scmpPlusPaywallTypeIds"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "withHarrysView"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "commentQueueQuery",
  "selections": [
    {
      "alias": "commentSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "93"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "followButtonBase"
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"93\"})"
    },
    {
      "alias": "commentQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "commentQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "commentLimit"
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "commentContentItemContent"
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "withHarrysView",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "harryContents",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "paywallTypeIds",
                  "variableName": "scmpPlusPaywallTypeIds"
                }
              ],
              "kind": "ObjectValue",
              "name": "articleExcludeInput"
            },
            {
              "kind": "Literal",
              "name": "contentTypes",
              "value": [
                "GALLERY"
              ]
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "sectionIds",
                  "variableName": "commentHarrySectionIds"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "harrysViewLimit"
            },
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": {
                "direction": "DESC",
                "field": "PUBLISHED_DATE"
              }
            }
          ],
          "concreteType": "ContentConnection",
          "kind": "LinkedField",
          "name": "contents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "harryContentItemContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "aca1c48db28e6bbf987e8998d4531f52";

export default node;
